import React, { useMemo } from 'react';
import {
  Button, Card, Spinner, Alert,
} from 'react-bootstrap';

import Accordion from 'components/Accordion';
import buildAccordionClickFunction from 'helper/buildAccordionClickFunction';
import { useListSimilarityVariablesQuery } from 'services/api/Meteorology/Weather/Similarity';
import { useDispatch, useSelector } from 'react-redux';
import { setVariavel, selectSimilaridadeVariavel } from 'redux/reducers/similaridadeReducer';

export default function Variable() {
  const closeAccordion = useMemo(() => buildAccordionClickFunction('similarity-variable-accordion'), []);
  const dispatch = useDispatch();

  const selectedVariable = useSelector(selectSimilaridadeVariavel);

  // Busca variáveis da API
  const { data: variables = [], isLoading, isError } = useListSimilarityVariablesQuery();

  return (
    <Accordion.Item eventKey="variable" id="similarity-variable-accordion">
      <Accordion.Header>Variável</Accordion.Header>
      <Accordion.Body>
        {isLoading && (
          <div className="text-center p-3">
            <Spinner animation="border" size="sm" />
            <span className="ms-2">Carregando variáveis...</span>
          </div>
        )}

        {isError && (
          <Alert variant="danger">
            Erro ao carregar variáveis. Por favor, tente novamente.
          </Alert>
        )}

        {!isLoading && !isError && variables.map((v) => (
          <Card.Body key={v.id}>
            <Button
              variant="link"
              onClick={() => {
                dispatch(setVariavel(v.nome || v.label));
                closeAccordion();
              }}
              className={`w-100 btn-control-panel ${selectedVariable === (v.nome || v.label) ? 'btn-control-panel-active' : ''}`}
            >
              {v.nome}
            </Button>
          </Card.Body>
        ))}
      </Accordion.Body>
    </Accordion.Item>
  );
}
